class CartAttributes extends HTMLElement {
  constructor() {
    super();
    const tradeCustomerDropdown = this.querySelector("#trade-customer");

    if (tradeCustomerDropdown) {
      tradeCustomerDropdown.dispatchEvent(new Event("change"));
    }

    this.toggleCheckoutButton();

    // When a form element is changed
    this.addEventListener("change", (event) => {
      event.preventDefault();

      var formData = new FormData();
      const tradeCustomerDropdown = this.querySelector("#trade-customer");
      const tradeCustomerFields = this.querySelector("#trade-customer-fields");
      var vatNumberInput = document.getElementById("vat-number");
      var eoriNumberInput = document.getElementById("eori-number");
      var tradeCustomerInfo = document.getElementById("cart-attribute-info");

      if (tradeCustomerDropdown) {
        // If trade customer
        if (tradeCustomerDropdown.value === "yes") {
          // Show additional trade fields
          tradeCustomerFields.style.display = "block";
          tradeCustomerInfo.style.display = "block";
          formData.append("attributes[trade_customer]", "yes");
          formData.append("attributes[customer_VAT]", vatNumberInput.value);
          formData.append("attributes[customer_EORI]", eoriNumberInput.value);

          // Update cart attributes
          fetch(window.Shopify.routes.root + "cart/update.js", {
            method: "POST",
            body: formData,
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("Cart updated:", data);
            })
            .catch((error) => {
              console.error("Error updating cart:", error);
            });
        } else {
          // Hide additional trade fields
          tradeCustomerFields.style.display = "none";
          tradeCustomerInfo.style.display = "none";
          formData.append("attributes[trade_customer]", "no");
          formData.append("attributes[customer_VAT]", "");
          formData.append("attributes[customer_EORI]", "");
          // Update cart attributes
          fetch(window.Shopify.routes.root + "cart/update.js", {
            method: "POST",
            body: formData,
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("Cart updated:", data);
            })
            .catch((error) => {
              console.error("Error updating cart:", error);
            });
        }
      }
      this.toggleCheckoutButton();
    });

    this.toggleCheckoutButton();
  }

  // Check if all details have been provided to enable checkout
  toggleCheckoutButton() {
    var checkoutButton = document.querySelector('button[name="checkout"]');
    const tradeCustomerDropdown = this.querySelector("#trade-customer");
    var vatNumberInput = document.getElementById("vat-number");
    var eoriNumberInput = document.getElementById("eori-number");
    var cartWarning = document.getElementById("cart-attribute-warning");
    if (tradeCustomerDropdown.value === "yes") {
      if (vatNumberInput.value && eoriNumberInput.value) {
        checkoutButton.disabled = false;
        cartWarning.style.display = "none";
        // console.log("Checkout enabled for trade customer");
      } else {
        checkoutButton.disabled = true;
        cartWarning.style.display = "block";
        // console.log("Checkout disabled until VAT and EORI numbers are entered");
      }
    } else if (tradeCustomerDropdown.value === "no") {
      checkoutButton.disabled = false;
      cartWarning.style.display = "none";
      // console.log("checkout enabled for non-trade customer");
    } else {
      checkoutButton.disabled = true;
      cartWarning.style.display = "block";

      // console.log("checkout disabled");
    }
  }
}

customElements.define("cart-attributes", CartAttributes);
